import theme from '../base'
import { alpha } from '@mui/material/styles'

const backdrop = {
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: alpha(theme.palette.neutral.main, 0.4),
        [theme.breakpoints.up('sm')]: {
          backgroundColor: alpha(theme.palette.neutral.main, 0.2),
        },
      },
      invisible: {
        backgroundColor: 'transparent',
      },
    },
  },
}

export default backdrop
